<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'" type="radio" label="运营模式" name="operation_mode" :options="operationMode"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="hidden" name="stationed_id"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name" readonly @click="$refs.stationedSelector.open()"></c-form-item>
					<c-form-item type="input" label="订单号" name="order_number"></c-form-item>
					<c-form-item type="input" label="物流单号" name="logistics_number"></c-form-item>
					<c-form-item type="input" label="客户手机号" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="input" label="用户昵称" name="nick_name"></c-form-item>
					<!-- <c-form-item type="input" label="业务员姓名" name="salesman_realname"></c-form-item> -->
					<c-form-item type="input" label="商品名称" name="product_name" placeholder="模糊匹配"></c-form-item>
					<c-form-item type="input" label="收货人" name="receiving_name"></c-form-item>
					<c-form-item type="input" label="收货人电话" name="receiving_phone"></c-form-item>
                    <c-form-item type="input" label="交付门店" name="service_center" placeholder="模糊匹配,支持门店名称、联系人信息搜索"></c-form-item>
					<c-form-item type="datetime" label="终端下单时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="datetime" label="终端付款时间" start-name="pay_start_date" end-name="pay_end_date"></c-form-item>
					<c-form-item type="checkbox" label="订单类型" name="order_type" :options="orderType"></c-form-item>
<!--
					<c-form-item type="checkbox" label="销售方式" name="order_classify" :options="orderClassify"></c-form-item>
-->
					<!-- <c-form-item type="checkbox" v-if="systemConfig.order_check_enabled == 'ON' || systemConfig.cash_pay == 'ON'" label="审核状态" name="check_state" :options="checkState"></c-form-item> -->
					<c-form-item type="checkbox" label="订单状态" name="order_state" :options="orderState"></c-form-item>
					<c-form-item v-if="systemConfig.order_invoice_enabled == 'ON'" type="checkbox" label="开票状态" name="invoice_state" :options="invoiceState"></c-form-item>
					<c-form-item v-if="systemConfig.order_push_enabled == 'ON'" type="checkbox" label="推送状态" name="push_state" :options="pushState"></c-form-item>
				</c-form>
			</m-search>
			<m-operate>
				<c-button power="b_order_export" @click="exportData()" icon="export">导出订单明细</c-button>
				<c-button power="b_order_deliver" @click="importDeliver()" color="gray" hollow icon="excel">导入发货</c-button>
				<c-button power="b_order_invoice_finish" v-if="systemConfig.order_invoice_enabled == 'ON'" @click="batchInvoiceFinish()">批量开票完成</c-button>
			</m-operate>
			<c-table ref="table">
				<c-table-column
					width="400"
				>
					<template slot="head">
						<!-- <c-checkbox></c-checkbox> -->
						<span style="margin-left: 15px;">商品信息</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="单价"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="数量"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="总金额"
					width="170"
					align-center
				></c-table-column>
				
				<c-table-column
					label="交易状态"
					width="170"
					align-center
				></c-table-column>
				
				<c-table-column
					label="操作"
					width="170"
					align-center
				></c-table-column>
				
				<template #custom="{data}">
					<div :key="data.id" class="order">
                        <div class="order-head flex-between-center">
                            <div class="flex-center">
                                <input  type="checkbox" :value="data.order_number" v-model="data.checked"/>
                                <span class="number">
                                     订单号：
                                    <a style="color:blue;" @click="navigateTo(`/order_detail/${data.order_number}`)">
                                        {{data.order_number}}
                                    </a>
                                </span>
                                <div class="tag" v-if="data.order_classify == 1 && systemConfig.is_virtual_product == 'ON'"
                                     style="background: #00B2FB">实物
                                </div>
                                <div class="tag" v-if="data.order_classify == 2 && systemConfig.is_virtual_product == 'ON'"
                                     style="background: #FFDE00">虚拟
                                </div>
                                <div class="tag" v-if="data.is_cloud_stock == 1 && systemConfig.cloud_stock == 'ON'"
                                     style="background: #057215">囤货
                                </div>
                                <div class="tag" v-if="data.order_type!=1" style="background: #4686e0">
                                    {{ orderTypeName[data.order_type] }}
                                </div>
                                <p class="info" v-if="systemConfig.pt_mode == 2">
                                    归属商家：{{ data.stationed_name }}
                                </p>
                                <p class="info">
                                    终端下单时间：{{ data.create_date }}
                                </p>
                                <p class="info" v-if="data.payment_state == 3 && data.payment_date">
                                    终端支付时间：{{ data.payment_date }}
                                </p>
                                <p class="info" v-if="data.service_center">
                                    交付门店：{{data.service_center}}
                                </p>
                            </div>
                        </div>
                        <div class="order-head flex-between-center">
                            <div class="flex-center">
                                <span class="number">
                                  商户订单号： {{data.out_trade_no||'--'}}
                                </span>
                                <p class="info">
                                    三方支付号：{{data.third_number||'--'}}
                                </p>
                                <p class="info">
                                    转单至平台时间：{{ data.transfer_to_platform_date }}
                                </p>

                            </div>
                        </div>
                        <div class="order-head flex">
                            <span class="number">
                              买家：{{ data.nick_name || data.receiving_name }}
                              &nbsp;| &nbsp;{{ data.user_manage_mobilephone }}
                              &nbsp;| &nbsp;{{ data.order_user_level_name }}
                            </span>
                            <p class="info"
                               v-if="data.receiving_name && data.receiving_phone && data.receiving_address">
                                收货信息：{{ data.receiving_name }}；{{ data.receiving_phone }}；{{ data.receiving_address }}
                                <a power="b_order_deliver"
                                   v-if="data.operation_mode != 2 &&  data.refund_flag != 1 && data.return_flag!=1 && (data.order_state == 1 || data.order_state == 2)"
                                   style="margin-left: 5px;color:blue" @click="$refs.orderAddressEdit.open(data.order_number)">修改</a>
                            </p>
                            <div class="info flex flex-grow" v-if="data.send_logistics_number_list && data.send_logistics_number_list.length > 0">
                                <p>发货物流：</p>
                                <div class="flex-grow flex-wrap">
                                    <template v-for="(item, i) in data.send_logistics_number_list">
                                        <p :key="i" style="max-width: 100%; word-break: break-all; white-space: normal;">
                                            <span>{{ item.logistics_company }}</span>
                                            <span v-if="item.logistics_number">({{ item.logistics_number || '--' }})</span>
                                            <a style="margin-left: 5px;color:blue;" power="b_order_deliver" v-if="data.order_state == 3" @click="editLogisticsCompany(item)">修改</a>
                                            <span>；</span>
                                        </p>
                                    </template>
                                </div>
                            </div>
                        </div>
						<div class="flex">
							<div class="order-product">
								<div v-for="(sku, i) in data.product_sku_list" :key="i" class="sku flex-center">
									<div class="sku-info flex-center flex-grow">
										<c-image class="sku-image" :src="sku.product_img_url"></c-image>
										<div class="flex-grow">
											<p class="sku-name ellipsis">{{sku.product_name}}</p>
											<p class="sku-sku">{{sku.product_sku_spec}}</p>
										</div>
									</div>
									<div class="sku-price">￥{{sku.product_unit_price}}</div>
									<div class="sku-count">{{sku.product_count}}</div>
								</div>
							</div>
							<div class="order-sum flex-column flex-center">
								<span v-if="data.order_type==2 && data.payment_state == 1">
									{{data.product_money}}积分
								</span>
								<span v-if="data.order_type==2 && data.payment_state != 1">
									{{data.payment_money}}积分
								</span>
								<span v-if="data.order_type==2 && data.logistics_money > 0">
									(另运费￥{{parseFloat(data.logistics_money).toFixed(2)}})
								</span>
								<span v-if="data.order_type!=2 && data.payment_state != 3">
									￥{{parseFloat(data.product_money+data.custom_money +data.logistics_money + data.total_fee_money).toFixed(2)}}
								</span>
								<span v-if="data.order_type!=2 && data.payment_state == 3">
									￥{{parseFloat(data.payment_money).toFixed(2)}}
								</span>
								<span v-if="data.order_type!=2 && data.logistics_money > 0" >
									(含运费￥{{parseFloat(data.logistics_money).toFixed(2)}})
								</span>
								<span v-if="data.order_type!=2 && data.total_fee_money > 0" style="color:orangered">
									(含服务费￥{{parseFloat(data.total_fee_money).toFixed(2)}})
								</span>
								<span v-if="data.order_type==7 && data.custom_money > 0" style="color:orangered">
									(含定制费￥{{parseFloat(data.custom_money).toFixed(2)}})
								</span>
							</div>
							<div class="order-state flex-column flex-center">
								<span v-if="data.check_state==1 && data.payment_type=='银行转账'" style="color:#182eff">待审核</span>
								<span v-if="data.check_state==3" style="color:#ff5555">审核驳回</span>
								<span v-if="data.check_state==2">
									{{orderStateName[data.order_state]}}
									<span v-if="data.return_flag==1">(售后中)</span>
									<span v-else-if="data.refund_flag==1">(未发退款中)</span>
								</span>
								<span v-if="data.order_state == 3">({{data.deliver_state}})</span>
								<a @click="navigateTo(`/order_detail/${data.order_number}`)">订单详情</a>
							</div>
							<div class="order-handle flex-column flex-center">
								<c-button color="gray" hollow v-if="data.check_state==1 && data.order_state != 6" @click="navigateTo(`/order_detail/${data.order_number}`)">审批</c-button>
								<c-button color="gray" hollow power="b_order_deliver" v-if="data.refund_flag==0 && data.return_flag==0 && data.check_state == 2 && (data.order_state == 2 || (data.order_state == 3 && data.deliver_state =='部分发货'))" @click="openSendDilog(data.order_number)">发货</c-button>
								<c-button color="gray" hollow power="b_order_refund_apply"  v-if="(data.order_type == 1 || data.order_type == 5 || data.order_type == 6) && data.check_state == 2 && data.refund_flag!=1 && data.return_flag!=1 && (data.order_state==2 || data.order_state==3 || data.order_state==5) && data.deadline_state == 1" @click="navigateTo(`/after_sales_apply?orderNumber=${data.order_number}`)">申请售后</c-button>
								<c-button color="gray" hollow power="b_order_close" v-if="data.refund_flag != 1 && data.return_flag!=1 && (data.order_state == 1 || data.order_state == 2) && !(data.payment_state == 1 && data.payment_type=='银行转账')" @click="closeHandle(false,data)">关闭</c-button>
								<c-button color="gray" hollow v-if="data.check_state == 2 && data.refund_flag!=1 && data.return_flag!=1 && data.invoice_state == 1 && data.invoice_count > 0 && (data.order_state == 3 || data.order_state == 5)" power="b_order_invoice_finish" @click="onInvoiceFinish(data)">开票完成</c-button>
								<c-button color="gray" hollow v-if="systemConfig.order_invoice_enabled == 'ON' &&  data.refund_flag != 1 && data.return_flag!=1 && (data.order_state == 1 || data.order_state == 2)" power="b_order_edit_receiving_address" @click="editReceivingAddress(data)">修改收货信息</c-button>
								<c-button color="gray" hollow v-if="data.check_state == 2 && data.order_state != 1 && data.order_state != 6" power="b_order_download" @click="downOrder(data,0)">下载订单</c-button>
							</div>
						</div>
					</div>
				</template>
			</c-table>
		</module>
		<!-- 关闭订单弹框 -->
		<c-dialog ref="closeDia" :title="'取消订单-'+orderNumber" width="600" @resolve="closeHandle">
			<div class="order-verify">
			  	<textarea v-model="cancel_reason" placeholder="请输入取消原因..."></textarea>
			</div>
		</c-dialog>
		<!--修改收货地址弹框 -->
		<c-dialog ref="receivingDia" title="修改收货地址" width="700" @resolve="receivingSubmitForm">
		    <c-form ref="receivingForm">
		        <c-form-item type="hidden" name="order_number"></c-form-item>
		        <c-form-item type="input" label="收货人" name="receiving_name" required></c-form-item>
		        <c-form-item type="input" label="电话" name="receiving_phone" required></c-form-item>
		        <c-form-item type="input" label="收货地址" name="receiving_address" required></c-form-item>
		    </c-form>
		</c-dialog>
		<!--开票完成弹框 -->
		<c-dialog ref="invoiceConf" title="开票确认" button-name="确认开票完成" width="550" height="360" @resolve="submitInvoiceFinish">
			<c-form ref="invoiceConfForm">
			<div class="invoice">
				<p v-html="text_msg"></p>
				<c-form-item type="datetime" v-model="invoiceDate" label="开票时间" ></c-form-item>
				<c-form-item type="number" v-if="is_bath == 0" v-model="realityMoney" :limit="9999999" decimal="2" label="实收金额" ></c-form-item>
				<p v-if="is_bath == 1" style="color:red">批量开票时,默认实收金额与订单支付金额一致</p>
                <c-form-item type="radio" v-if="is_bath == 0" label="开票凭证" name="invoice_file_type" v-model="invoice_file_type" :options="invoiceFileType"></c-form-item>
                <c-form-item type="file" v-if="is_bath == 0 && invoice_file_type == 1" label="附件" v-model="invoice_file" name="invoice_file" file-type="image,pdf"></c-form-item>
                <c-form-item type="input" v-if="is_bath == 0 && invoice_file_type == 2" label="链接" v-model="invoice_file" word="http://或https://开头" name="invoice_file" ></c-form-item>
			</div>
			</c-form>
		</c-dialog>
		
		<!--订单发货弹框（部分发货） -->
		<c-dialog ref="orderSend" :title="'订单发货-'+orderNumber" width="900" button-name="发货" @resolve="orderSendHandle">
			<c-detail style="padding:5px;">
				<c-detail-item label="收货人：">
					<p>{{orderDetail.receiving_name}}，{{orderDetail.receiving_phone}}</p>
				</c-detail-item>
				<c-detail-item label="收货地址：">
					<p>{{orderDetail.receiving_address}}</p>
				</c-detail-item>
				<c-detail-item label="配送方式：">
					<p>{{orderDetail.logistics_company_name}}</p>
				</c-detail-item>
				<c-detail-item label="买家留言：" column="2">
					<p>{{orderDetail.order_remark?orderDetail.order_remark:'--'}}</p>
				</c-detail-item>
			</c-detail>
			<div style="background: #FAFAFA;">
        <m-operate>
            <c-checkbox :checked="this.self_pick" @change="changeSelfPick($event)"></c-checkbox> &nbsp;&nbsp;无需物流&nbsp;&nbsp;
            <c-button  @click="addCompany()" :disabled="self_pick">添加包裹</c-button>
        </m-operate>
        <c-table ref="orderSendCompany" v-model="sendCompanyList" height="200" :paging="false">
          <c-table-column
              label="物流公司"
              width="200"
          >
            <template v-slot="{data}">
                <c-select :options="logisticsCompany" v-model="data.logistics_company_name" :disabled="self_pick"></c-select>
            </template>
          </c-table-column>

          <c-table-column
              label="运单号"
              width="150"
          >
            <template v-slot="{data}">
                <c-input v-model="data.logistics_number" :disabled="self_pick"></c-input>
            </template>
          </c-table-column>

          <c-table-column label="操作" width="80">
              <template v-slot="row">
                <c-button color="sys"  v-if="sendCompanyList.length > 1" @click="row.remove()" >删除</c-button>
              </template>
          </c-table-column>
        </c-table>
			</div>
			<c-table ref="orderSendList" v-model="sendList" height="320" :paging="false">
				<c-table-column
					type="selector"
					:selected="() => true"
				></c-table-column>
				
				<c-table-column
					label="商品信息"
					width="300"
				>
					<template v-slot="{data}">
						<product-info :image="data.product_img_url" image-size="60" :name="data.product_name"></product-info>
					</template>
				</c-table-column>
				
				<c-table-column
					label="规格信息"
					name="product_sku_spec"
				></c-table-column>
				
				<c-table-column
					label="未发数量"
				>
					<template v-slot="{data}">
						×{{data.product_quantity}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="发货数量"
					width="150"
				>
					<template v-slot="{data, selected}">
						<c-input v-model="sendNum[data.product_sku]" type="number" width="100" :limit="[1, data.product_quantity]" :disabled="!selected"></c-input> 件
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>
		
		<!--订单发货弹框（全部发货） -->
		<c-dialog ref="orderSendAll" :title="'订单发货-'+orderNumber" width="500" button-name="发货" @resolve="orderSendHandle">
			<div style="background: #FAFAFA;">
				<c-form ref="orderSendAllForm">
					<c-form-item type="select" name="logistics_company_name" label="物流公司" :options="logisticsCompany" v-model="logistics_company_name"></c-form-item>
					<c-form-item type="input" name="logistics_number" label="运单号"></c-form-item>
				</c-form>
			</div>
		</c-dialog>
        <!--修改配送方式 -->
        <c-dialog ref="editLogisticsCompanyDia" title="修改发货物流" width="700" @resolve="editLogisticsCompanyHandle">
            <c-form ref="editLogisticsCompanyForm">
                <c-form-item type="hidden" name="id"></c-form-item>
                <c-form-item type="input" label="订单号" name="order_number" :disabled="true"></c-form-item>
                <c-form-item type="select" label="发货物流：" :options="logisticsCompanyId" name="logistics_id" v-model="logistics_id" required></c-form-item>
                <c-form-item type="input" label="运单号码：" name="logistics_number" required></c-form-item>
            </c-form>
        </c-dialog>
        <order-address-edit ref="orderAddressEdit" @resolve="$refs.table.update();"></order-address-edit>
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
	</page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
    import orderAddressEdit from '@/components/service/order_address_edit.vue'  // 编辑订单收货地址
    import {mapState} from 'vuex'
	export default {
		name: 'm_order_sell',

		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
			stationedSelector,productInfo,orderAddressEdit
		},

        props: {
            check_state: String,
            order_state: String,
            invoice_state: String,
            pay_state: String,
            reconciliation_state: String
        },

        data() {
          return {
            is_bath:0,
            text_msg:'',
            realityMoney: 0,
            invoiceDate:'',	//开票时间
            cancel_reason:'', //关闭原因
            invoice_file_type:'',//开票文件类型
            invoice_file:'',//发票文件
            logistics_company_name:'',
            logistics_id:'',
            self_pick:false,//1=自提
            logisticsCompany: [],
            logisticsCompanyId: [],
            orderDetail: {},
            orderNumber: '',
            sendList: [],
            sendNum: {},
            orderStateName: {
              1: '待付款',
              2: '待发货',
              3: '待收货',
              5: '交易完结',
              6: '已关闭'
            },
            orderModeName: {
              1: '平台自营',
              2: '商家自营'
            },
            orderTypeName: {
              1: '普通',
              2: '积分',
              3: '赠品',
              4: '砍价',
              5: '预定全款',
              6: '预定定金',
              7: '定制',
              18: '搭配购',
              19: '一元购',
              99: '微信小店'
            },
            orderClassifyName: {
              1: '供货',
              2: '直销'
            },
            orderSourceName: {
              'OMS':'管理后台',
              'IOS': '苹果',
              'ANDROID': '安卓',
              'MINI': '小程序',
              'PC': 'PC电脑'
            },
            freightPaymentTypeName:{
              1: '运费先付',
              2: '运费到付'
            },
            orderState: [{
                name: '待付款',
                value: 1
              },{
                name: '待发货',
                value: 2
              },{
                name: '待收货',
                value: 3
              },{
                name: '交易完结',
                value: 5
              },{
                name: '已关闭',
                value: 6
              }
            ],
            checkState: [{
                name: '待审核',
                value: 1
              },{
                name: '审核通过',
                value: 2
              },{
                name: '审核不通过',
                value: 3
              }
            ],
            invoiceStateName: {
              0: '无需开票',
              1: '未开票',
              2: '已开票'
            },
            pushState: [{
                name: '无需推送',
                value: 0
              },{
                name: '待推送',
                value: 1
              },{
                name: '已推送',
                value: 3
              }
            ],
            operationMode: [{
                name: '平台自营',
                value: 1
              },{
                name: '商家运营',
                value: 2
              }
            ],
            invoiceState:[{
                name: '无需开票',
                value: 0
              },{
                name: '未开票',
                value: 1
              },{
                name: '已开票',
                value: 2
              }
            ],
            invoiceFileType:[{
                name: '附件',
                value: 1
            },{
                name: '链接',
                value: 2
            }],
            sendCompanyList:[],
            companyIdIndex:1
          }
        },

        computed: {
			...mapState(['systemConfig']),
          orderClassify(){
            return ([{
              name:'供货',
              value: 1
            },{
              name:'直销',
              value: 2
            }]);
          },
          orderType() {
            return (
              [{
                name: '普通',
                value: 1
              }, {
                  name: '赠品',
                  value: 3
              }, {
                  name: '搭配购',
                  value: 18
              }, {
                  name: '一元购',
                  value: 19
              }, {
                  name: '预定定金',
                  value: 6
              }, {
                  name: '预定全款',
                  value: 5
              }]
          );
          },
          defaultSearch() {
                let param = {
                    check_state: this.check_state ? this.check_state.split(',') : [],
                    order_state: this.order_state ? this.order_state.split(',') : [],
                    invoice_state: this.invoice_state ? this.invoice_state.split(',') : [],
                    reconciliation_state: this.reconciliation_state? this.reconciliation_state.split(',') : [],
                }

                if (this.pay_state == 1) {
                    param.pay_start_date = new Date().format('yyyy-MM-dd') + ' 00:00:00';
                    param.pay_end_date = new Date().format('yyyy-MM-dd') + ' 23:59:59';
                }

                return param;
            }
        },

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },

        mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
            this.$bus.$on('order.update', data => {
                // 刷新列表
                this.$refs.table.update();
            });
            this.initLogisticsCompany();
        },


		methods: {
            //初始化发货物流公司
            initLogisticsCompany(){
                if (!this.logisticsCompany.length||!this.logisticsCompanyId.length) {
                    this.request({
                        url: '/standard_logistics/list',
                        success: data => {
                            this.logisticsCompany = Array.from(data, item => {
                                return {
                                    name: item.option,
                                    value: item.option
                                };
                            });
                            this.logisticsCompanyId = Array.from(data, item => {
                                return {
                                    name: item.option,
                                    value: item.id
                                };
                            });
                        }
                    });
                }
            },
			//搜索
			searchHandle(data) {
				data.stationed_type = 1;
				data.check_state = [2];
				this.searchDate = data;
				this.$refs.table.load({
					url: '/order/detail_list',
					data
				});
			},
			//关闭订单（弹框）
			closeHandle(stop,data){
				if (!stop) {
					this.orderNumber = data.order_number;
					this.cancel_reason = '';
					this.$refs.closeDia.open();
				} else {
					stop();
					if (!this.cancel_reason.trim()) {
						this.$message({
							text: '请填写关闭订单原因'
						});
						return;
					}
					this.closeSubmitForm();
					this.$refs.closeDia.close();
					this.$bus.$emit('order.update', {});
				
				}
			},
			//关闭订单（提交数据）
			closeSubmitForm() {
				this.request({
					url: '/order/cancel',
					data: {
						order_number: this.orderNumber,
						cancel_reason: this.cancel_reason.trim()
					},
					loading: true,
					success: () => {
						this.$message({
							icon: 'success',  
							text: '申请取消订单成功'
						});
						this.$refs.table.update();
					}
				});
			},
			//修改收货地址（弹框）
            editReceivingAddress(val){
                this.$refs.receivingForm.clear();
                this.$refs.receivingForm.set(val);
                this.$refs.receivingDia.open();
            },
			//修改收货地址（提交数据）
            receivingSubmitForm(stop){
                stop();
                this.$refs.receivingForm.submit({
                    url: '/order/edit_receiving_address',
                    rule: {
                        receiving_name: '请填写收货人',
                        receiving_phone: '请填写电话',
                        receiving_address: '请填写收货地址',
                    },
                    dataFormatter: data => {
                        return data;
                    },
                    success: (data, res) => {
                        this.$message({
                            text: '修改收货信息成功！'
                        });
                        this.$refs.table.update();
                        this.$refs.receivingDia.close();
                    }
                });
            },
			//订单下载
			downOrder(d,type){
				this.request({
				    url: '/order/getdownloadurl',
				    data: {
				        order_number: d.order_number,
						type: type
				    },
				    loading: true,
				    success: data => {
				        window.open(data);
				    }
				});
			},
			//批量导出订单
			exportData() {
				var data = this.searchDate;
				data.job_id = 34;
				data.order_numbers = Array.from(this.$refs.table.getRow('selected'), item => item.data.order_number);
				this.request({
					url: '/export_job/add',
					data: data,
					loading: true,
					success: data => {
						this.$message({
							text: '订单导出任务提交成功，请稍后前往任务中心查看'
						});
					}
				});
				
			},
			//单个开票完成
			onInvoiceFinish(data) {
				var text_msg = `确定要对订单【<font style="font-size:15px;color:red;">${data.order_number}</font>】执行开票完成操作吗？`;
				this.realityMoney = (parseFloat(data.payment_money) || 0).toFixed(2);
				this.is_bath = 0;
				this.openInvoiceFinish(text_msg,[data.id]);
			},
			//批量开票完成
			batchInvoiceFinish() {
				this.is_bath = 1;
				this.realityMoney = null;
				var selectDatas = this.$refs.table.getRow('selected');
				var is_flag = true;
				if (!selectDatas.length) {
					stop();
					this.$message({
						text: '请选择需要执行开票完成的订单'
					});
					return;
				}
				
				selectDatas.forEach(item => {
					if(item.data.order_state !=5 || item.data.invoice_count <= 0 || item.data.invoice_state == 2 || item.data.check_state == 1){
						is_flag = false;
					}
				});
				
				if(!is_flag){
					this.$message({
						icon: 'fail',  // 图标（success：成功，fail：失败）
						text: '选择的订单中存在不符合开票条件的订单！'
					});
					return;
				}
				var order_ids = Array.from(selectDatas, item => item.data.id);
				var text_msg = `确定要对已选的【<font style="font-size:15px;color:red;">${selectDatas.length}笔</font>】订单执行开票完成操作吗？`;
				this.openInvoiceFinish(text_msg,order_ids);
				
			},
			//开票完成弹框
			openInvoiceFinish(text_msg,order_ids){
				this.text_msg = text_msg;
				this.order_ids = order_ids;
				this.invoiceDate = new Date().format('yyyy-MM-dd hh:mm:ss');
				this.invoice_file_type = 1;
				this.invoice_file = '';
				this.$refs.invoiceConf.open();
			},
			//提交开票完成信息
			submitInvoiceFinish(stop){
				stop();
				if (!this.invoiceDate) {
					this.$message({
						text: '请选择开票时间'
					});
					return;
				}
				if(this.is_bath == 0){
					if (!this.realityMoney) {
						this.$message({
							text: '请输入实收金额'
						});
						return;
					}
                    if (!this.invoice_file_type) {
                        this.$message({
                            text: '请选择开票凭证'
                        });
                        return;
                    }
                    if (!this.invoice_file) {
                        if(this.invoice_file_type == 1){
                            this.$message({
                                text: '请上传附件'
                            });
                            return;
                        }
                        if(this.invoice_file_type == 2){
                            this.$message({
                                text: '请输入链接'
                            });
                            return;
                        }
                    } else if (this.invoice_file_type == 2 ) {
                        if(this.invoice_file.indexOf('http://') !== 0 && this.invoice_file.indexOf('https://') !== 0){
                            this.$message({
                                text: '请输入以http://或https://开头的完整链接'
                            });
                            return;
                        }
					}
				}
				this.request({
					url: '/order/invoice_finish',
					data: {
						order_ids: this.order_ids,
						invoice_date: this.invoiceDate,
						reality_money: this.realityMoney,
						is_bath: this.is_bath,
                        invoice_file_type: this.invoice_file_type,
                        invoice_file: this.invoice_file
					},
					loading: true,
					success: data => {
						this.$message({
							icon: 'success',  
							text: '执行开票完成操作成功'
						});
						this.$refs.table.update();
						this.$refs.invoiceConf.close();
						this.$refs.invoiceConfForm.clear();
					}
				});
			},
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			},
			openSendDilog(order_number){
				this.orderNumber = order_number;
				this.request({
					url: '/order/detail',
					data: {
						order_number: this.orderNumber
					},
					loading: true,
					success: data => {
						this.orderDetail = data.base_info;
						this.companyIdIndex = 1;
						this.sendCompanyList = [{
							id:this.companyIdIndex,
							logistics_company_name:'',
							logistics_number:''
						}];

						this.request({
							url: '/order/undelivered/product/list',
							data: {
								order_number: this.orderNumber
							},
							loading: true,
							success: data => {
								this.sendList = data;
								this.logistics_company_name = this.orderDetail.last_logistics_company
								this.$refs.orderSend.open();
								//赋值默认发货数量
								this.sendList.forEach(item => {
									this.sendNum[item.product_sku] = item.product_quantity;
								});

							}
						});
					}
				});
			},

			//订单发货（部分发货）
			orderSendHandle(stop, next, order_number) {
				if (!stop) {
					this.orderNumber = order_number;

					this.request({
						url: '/order/detail',
						data: {
							order_number: this.orderNumber
						},
						loading: true,
						success: data => {
							this.orderDetail = data.base_info;
                            this.companyIdIndex = 1;
                            this.sendCompanyList = [{
                              id:this.companyIdIndex,
                              logistics_company_name:'',
                              logistics_number:''
                            }];
							if (!this.logisticsCompany.length) {
								this.request({
									url: '/standard_logistics/list',
									success: data => {
										this.logisticsCompany = Array.from(data, item => {
											return {
												name: item.option,
												value: item.option
											};
										});
									}
								});
							}
							
							this.request({
								url: '/order/undelivered/product/list',
								data: {
									order_number: this.orderNumber
								},
								loading: true,
								success: data => {
									this.sendList = data;
									this.logistics_company_name = this.orderDetail.last_logistics_company
									this.$refs.orderSend.open();
									//赋值默认发货数量
									this.sendList.forEach(item => {
										this.sendNum[item.product_sku] = item.product_quantity;
									});
									
								}
							});
						}
					});
					
				} else {
					stop();
					let list = this.$refs.orderSendList.getRow('selected');
					
					new Promise(resolve => {
                            if (!this.self_pick && (!this.sendCompanyList || this.sendCompanyList.length==0)){
                                resolve('请填写物流公司信息');
                            }
                            if (!this.self_pick && this.sendCompanyList.find(item => {
                              return (!item.logistics_company_name || item.logistics_company_name=='');
                            })) {
                              resolve('请填写物流公司信息');
                            }
                            if (!this.self_pick && this.sendCompanyList.find(item => {
                              return (!this.self_pick && item.logistics_company_name!='自提'&&(!item.logistics_number || item.logistics_number==''));
                            })) {
                                resolve('请填写运单号信息');
                            }
                            //查询运单号是否重复
                            let logistics_numbers = this.sendCompanyList.filter((item, index, self) => {
                              // 返回第一个匹配项的索引，用于判断当前项是否为第一个匹配项
                              const firstIndex = self.findIndex((obj) => obj.logistics_number === item.logistics_number);
                              // 如果当前项是第一个匹配项，则保留，否则过滤掉
                              return index === firstIndex;
                            });
                            if (logistics_numbers.length != this.sendCompanyList.length){
                              resolve('存在重复的运单号，请检查');
                            }
                            if (list.find(item => {
                              return (parseInt(this.sendNum[item.data.product_sku]) || 0) <= 0;
                            })) {
                              resolve('请填写已选商品的发货数量');
                            }

						if (!list.length) {
							resolve('请选择要发货的商品');
						}
						
						if (list.find(item => {
							return (parseInt(this.sendNum[item.data.product_sku]) || 0) <= 0;
						})) {
							resolve('请填写已选商品的发货数量');
						}
						
						resolve(false);
					}).then(error => {
						if (error) {
							this.$message({
								text: error
							});
							return;
						}
						
						this.request({
							url: '/order/deliver',
							data:{
                                  order_number: this.orderNumber,
                                  send_products: Array.from(list, item => {
                                    return {
                                      product_sku: item.data.product_sku,
                                      send_quantity: parseInt(this.sendNum[item.data.product_sku])
                                    }
                                  }),
                                  self_pick:this.self_pick?1:0,
                                  logistics_company_list: this.self_pick?[]:Array.from(this.sendCompanyList, item => {
                                    return {
                                      logistics_company_name: item.logistics_company_name,
                                      logistics_number: item.logistics_number
                                    }
                                  })
							},
							loading: true,
							success: data => {
								this.$refs.orderSend.close();
								this.$message({
									text: '发货成功'
								});
								this.$refs.table.update();
							}
						});
					});
				}
			},
			
			//订单发货（全部发货）
			orderSendAllHandle(stop, next, order_number) {
				if (!stop) {
					this.orderNumber = order_number;
					this.request({
						url: '/order/detail',
						data: {
							order_number: this.orderNumber
						},
						loading: true,
						success: data => {
							this.orderDetail = data.base_info;
							
							if (!this.logisticsCompany.length) {
								this.request({
									url: '/standard_logistics/list',
									success: data => {
										this.logisticsCompany = Array.from(data, item => {
											return {
												name: item.option,
												value: item.option
											};
										});
										this.$refs.orderSendAllForm.set({
											logistics_company_name: this.orderDetail.last_logistics_company
										});
									}
								});
							} else {
								this.$refs.orderSendAllForm.set({
									logistics_company_name: this.orderDetail.last_logistics_company
								});
							}
							this.$refs.orderSendAll.open();
						}
					});
					
				} else {
					stop();
					
					let form = this.$refs.orderSendAllForm.serialize();
					
					new Promise(resolve => {
						if (!form.logistics_company_name) {
							resolve('请选择物流公司');
						}
						
						if (form.logistics_company_name!='自提' && !form.logistics_number) {
							resolve('请填写运单号');
						}
						resolve(false);
					}).then(error => {
						if (error) {
							this.$message({
								text: error
							});
							return;
						}
						
						this.request({
							url: '/order/deliverall',
							data: Object.assign(form, {
								order_number: this.orderNumber
							}),
							loading: true,
							success: data => {
								this.$refs.orderSendAll.close();
								this.$message({
									text: '发货成功'
								});
							}
						});
					});
				}
			},

          changeSelfPick(state) {
              this.self_pick = state;
          },

          addCompany(){
                this.companyIdIndex = this.companyIdIndex + 1;
                  var compamyObj = {};
                  compamyObj.id = this.companyIdIndex;
                  compamyObj.logistics_company_name = '';
                  compamyObj.logistics_number = '';
                  this.sendCompanyList.push(compamyObj);
          },
          //导入发货
          importDeliver() {
            this.$confirm({
                title: '导入提示',
                buttonName: '开始导入',  // 确定按钮文字
                text: '请使用标准模板进行导入发货 <a href="https://qyscimg.oss-cn-hangzhou.aliyuncs.com/app_static/%E5%AF%BC%E5%85%A5%E5%8F%91%E8%B4%A7%E6%A8%A1%E6%9D%BF.xlsx" target="_blank" style="color:dodgerblue;">模板下载</a>',
                resolve: () => {
                    this.uploadFile({
                        message: false,
                        success: data => {
                            this.request({
                                url: '/order/importDeliver',
                                data: {
                                    filePath: data.filePath
                                },
                                loading: true,
                                timeout: false,
                                success: (data, message) => {
                                    this.$refs.table.update();
                                    this.$confirm({
                                        title: '执行结果',
                                        text: message,  // 提示内容,
                                        buttonName: '确定',  // 确定按钮文字
                                        icon: 'success',
                                        cancelButton: false  // 是否显示取消按钮
                                    });
                                }
                            });
                        }
                    })
                }
            });
        },
          //修改发货物流（弹框）
          editLogisticsCompany(val) {
            this.logistics_id = val.logistics_id||0;
            this.$refs.editLogisticsCompanyForm.clear();
            this.$refs.editLogisticsCompanyForm.set(val);
            this.$refs.editLogisticsCompanyDia.open();
         },
          //编辑运单号响应事件
          editLogisticsCompanyHandle(stop) {
                stop();
                this.$refs.editLogisticsCompanyForm.submit({
                    url: '/order/edit_logistics_company',
                    rule: {
                        logistics_id: '请选择发货物流信息',
                        logistics_number: [{
                            type: 'empty',
                            skip: (d) => {
                                return d.logistics_id < 0;
                            },
                            word: '请填写运单号码信息'
                        }]
                    },
                    dataFormatter: data => {
                        return data;
                    },
                    success: (data, res) => {
                        this.$message({
                            text: '修改发货物流成功！'
                        });
                        this.$refs.table.update();
                        this.$refs.editLogisticsCompanyDia.close();
                    }
                });
            },
		}
	}
</script>
<style lang="stylus" scoped>
.order {
    &-verify {
        padding: 20px;

        textarea {
            box-sizing: border-box;
            width: 100%;
            height: 120px;
            border: none;
            padding: 10px 14px;
            line-height: 20px;
            background: #FAFAFA;
            resize: none;
        }
    }
}

.order {
    border: 1px solid #eee;
    margin: 16px 0;

    &-head {
        border-bottom: 1px solid #eee;
        padding: 6px 8px;
        line-height: 22px;
        font-size: 12px;
        background: #F8F8F8;

        .number {
            margin-left: 10px;
            color: #333;
        }

        .tag {
            align-self: center;
            border-radius: 2px;
            padding: 0 5px;
            margin-left: 6px;
            line-height: 18px;
            color: #fff;
        }

        .info {
            position: relative;
            padding-left: 10px;
            white-space: nowrap;
            color: #999;

            &:nth-child(n+2) {
                &:after {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 3px;
                    height: 16px;
                    border-left: 1px solid #999;
                }

                margin-left: 10px;
            }
        }
    }

    &-product {
        flex-grow: 790;
        flex-basis: 790px;

        .sku {
            &:nth-child(n+2) {
                border-top: 1px solid #eee;
            }

            &-info {
                flex-grow: 400;
                flex-basis: 400px;
                box-sizing: border-box;
                padding: 10px 0 10px 14px;
            }

            &-image {
                width: 80px;
                height: 80px;
                margin-right: 24px;
            }

            &-name {
                font-size: 12px;
                color: #666;
            }

            &-sku {
                margin-top: 10px;
                font-size: 12px;
            }

            &-price,
            &-code,
            &-count {
                flex-grow: 130;
                flex-basis: 130px;
                font-size: 13px;
                text-align: center;
                color: #333;
            }
        }
    }

    &-sum,
    &-state,
    &-handle {
        flex-grow: 170;
        flex-basis: 170px;
        box-sizing: border-box;
        border-left: 1px solid #eee;
    }

    &-sum {
        line-height: 20px;
        font-size: 12px;
        text-align: center;
        color: #333;

        span {
            color: #888;
        }
    }

    &-state {
        line-height: 20px;
        font-size: 12px;

        a {
            color: #0060EF;
        }
    }

    &-handle {
        padding: 10px 0;

        .c-button {
            width: 6em;

            &:nth-child(n+2) {
                margin-top: 8px;
            }
        }
    }
}

.invoice {
    padding: 5px 10px;
    box-sizing: border-box;

    p {
        font-weight: bold;
        margin-bottom: 30px;
        font-size: 15px;
    }
}
</style>